"use client"
import { useEffect } from "react"
import { useRouter } from "next/navigation"
import { Header } from "@/components/header"
import { LiveDemoSection } from "@/components/live-demo-section"
import { Hero } from "@/components/hero"
import { DemoTabs } from "@/components/demo-tabs"
import { TemplateShowcase } from "@/components/template-showcase"
import { useReveal } from "@/hooks/use-reveal"
import { HeroShowcase } from "@/components/hero-showcase"
import { FeatureSections } from "@/components/feature-sections"
import { HowItWorks } from "@/components/how-it-works"
import { Pricing } from "@/components/pricing"
import { LogoMarquee } from "@/components/logo-marquee"
import { Testimonials } from "@/components/testimonials"
import { FAQ } from "@/components/faq"
import { Footer } from "@/components/footer"
import { useSubscriptionEvents } from "@/hooks/use-subscription-events"

export default function HomePage() {
  const router = useRouter()
  useReveal()
  
  // 启用SSE订阅事件监听
  useSubscriptionEvents()

  useEffect(() => {
    // 处理URL中的锚点
    const hash = window.location.hash
    if (hash) {
      // 延迟一点时间确保页面完全加载
      setTimeout(() => {
        const element = document.querySelector(hash)
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          })
        }
      }, 100)
    }
  }, [])

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16">
        {/* Unified gradient background block for top interactive + feature areas */}
        <div className="bg-gradient-to-b from-blue-50/70 via-white to-white dark:from-zinc-900 dark:via-zinc-900 dark:to-zinc-950">
          {/* <div id="live-demo" className="scroll-mt-20 reveal reveal-delay-1">
            <LiveDemoSection />
          </div> */}
          <Hero />
          {/* 新增：Hero 下方标签式 Demo 预览 */}
          <DemoTabs />
          <HeroShowcase />
          <FeatureSections />
          <HowItWorks />
          {/* 下方继续保持同一背景色 */}
          {/* <TemplateShowcase />
          <Testimonials /> */}
          <Pricing />
          <FAQ />
        </div>
      </main>
      <Footer />
    </div>
  )
}
